import React, { useState } from 'react'
import { AllReservesComponent } from '../Components/Reserves/AllReservesComponent';
import { AReserveComponent } from '../Components/Reserve/AReserveComponent';
import { AReserveFoodsAndParking } from '../Components/FoodAndParkingReserve/AReserveFoodsAndParking';
// ======================================================================
export const CurrentUserReserves = ({ setLoading, showMessage }) => {
    const [view, setView] = useState('All');
    const [currentPage, setCurrentPage] = useState(1);
    const [version, setVersion] = useState(0);
    const [selectedId, setSelectedId] = useState(0);
    // ======================================================================
    return (
        <>
            {view == "All" ?
                <AllReservesComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    forCurrentUser={true}
                    version={version}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    onItemClick={(id) => { setSelectedId(id); setView('AReserve') }}
                /> : <></>}
            {view == "AReserve" ?
                <AReserveComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    reserveId={selectedId}
                    onBackClick={() => { setView('All') }}
                    onFoodClick={(id) => { setSelectedId(id); setView('AFoodReserve'); }}
                /> : <></>}
                {view === "AFoodReserve" ?
                                <AReserveFoodsAndParking
                                    setLoading={setLoading}
                                    showMessage={showMessage}
                                    reserveId={selectedId}
                                    //onBackClick={() => { setView('ShowSearch'); setVersion(v => v + 1); }}
                                     onBackClick={() => { setView('All') }}
                                    onPayCompleted={() => { setView('ShowSearch'); setVersion(v => v + 1); }}
                                /> : <></>}
        </>
    )
}
